import { initEnv, biliBridge, isSupport, inBiliApp } from "@bilibili/js-bridge";
import { isAndroid } from "@/utils/detect";

initEnv();
function isAppSupport(schemeName: string) {
  return new Promise((resolve, reject) => {
    isSupport(schemeName).then((support: boolean) => {
      if (support) {
        resolve(1);
      } else {
        reject();
      }
    });
  });
}

function callNative<T>(methodName: string, data: { [props: string]: any }): Promise<T> {
  return new Promise((resolve, reject) => {
    isAppSupport(methodName).then(() => {
      biliBridge.callNative({
        method: methodName,
        data: data,
        callback: (data) => {
          resolve(data);
        }
      });
    }, reject);
  });
}

export function shareTextToQQ() {
  if (isAndroid) {
    return isInstalled("com.tencent.mobileqq", "mqq://").then(
      (isInstalled) => {
        if (!isInstalled) {
          return Promise.reject("QQ尚未安装，请安装后再分享");
        }
        openApp("mqq://");
      },
      () => {
        return Promise.reject("调起QQ失败，请自行打开");
      }
    );
  } else {
    return openApp("mqq://").then(
      () => {
        // alert('success:' + JSON.stringify(info));
      },
      () => {
        // alert('fail:' + JSON.stringify(info));
        return Promise.reject("分享失败，请安装APP后重试");
      }
    );
  }
}

export function shareTextToWechat(text: string) {
  return new Promise(() => {
    if (isAndroid) {
      isAppSupport("share.shareToTarget").then(
        () => {
          biliBridge.callNative({
            method: "share.shareToTarget",
            data: {
              target: "WEIXIN",
              weixin: {
                type: "text",
                title: text,
                text: text,
                url: location.href
              }
            },
            onShare: () => {
              // if (info.state === -2) {
              //     // alert('分享失败')
              // }
              // else if (info.state === 0) {
              //     // alert('分享成功')
              // }
              // alert(JSON.stringify(info));
            }
            // callback:(info: 'ok' | 'error') => {
            //     // info: ok 调用成功，error 调用失败
            //     alert(JSON.stringify(info));
            // }
          });
        },
        () => openApp("weixin://")
      );
    } else {
      openApp("weixin://").then(
        () => {
          // alert('success:' + JSON.stringify(info));
        },
        () => {
          // alert('fail:' + JSON.stringify(info));
          return Promise.reject("分享失败，请安装APP后重试");
        }
      );
    }
  });
}

export function openApp(scheme: string) {
  if (!inBiliApp) {
    return Promise.reject();
  }
  return callNative<{ code: number }>(isAndroid ? "ability.openScheme" : "biliapp.jumpToScheme", {
    url: scheme
  }).then((data) => {
    return data.code === 0 ? true : Promise.reject(data.code);
  });
}

export function openScheme(scheme: string) {
  if (!inBiliApp) {
    return Promise.reject();
  }
  return callNative<{ code: number }>("ability.openScheme", {
    url: scheme
  }).then((data) => {
    return data.code === 0 ? true : Promise.reject(data.code);
  });
}

export function isInstalled(pkgName: string, scheme: string) {
  if (inBiliApp && isAndroid) {
    return callNative<{ isInstalled: boolean }>("utils.isInstalled", {
      packageName: pkgName
    }).then((data) => data?.isInstalled);
  } else if (inBiliApp && !isAndroid) {
    return callNative<{ code: number; errMsg: string }>("ability.canOpenApplication", {
      url: scheme
    }).then((data) => {
      // info: {
      // "code": 0,// 0 可以打开, -1 不支持, -2 不在白名单, -3 未安装
      // "errMsg": "error"
      // }
      if (data.code === 0) {
        return true;
      } else if (data.code === -3) {
        return false;
      }
      // eslint-disable-next-line no-console
      console.warn(data);
      return Promise.reject();
    });
  }
  return Promise.reject();
}

export function openSafari(url: string) {
  biliBridge.callNative({
    method: "ability.openApplication",
    data: {
      url: url,
      ignoreQueriesSchemes: true
    }
  });
}

// 改变设备状态栏颜色
// mode 0: dark(状态栏黑字)，1: light(状态栏白字)
export function setStatusBarMode(mode: number) {
  biliBridge.callNative({
    method: "ui.setStatusBarMode",
    data: {
      mode
    }
  });
}

// 获取当前app信息
export function getContainerInfo() {
  return callNative<{ platform: string, build: number }>("global.getContainerInfo", {});
}